module.exports = __webpack_public_path__ + "img/save-button.03d75da8.svg";